import type { JumpChart } from '../jumpChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_CYAN } from '../builtinPulseMaps/palettes.js';
import { assembleJumpChartFromCircles } from './jumpFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/sky-high.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/sky-high-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/sky-high-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/sky-high-extreme.circles.json' with { type: 'json' };

export const SKY_HIGH_JUMP_VARIANTS: Record<Variant, JumpChart> = assembleJumpChartFromCircles({
  baseSlug: 'sky-high',
  baseTitle: "Sky High",
  description: "Anthemic progressive house from Elektronomia. Four-on-the-floor groove, steady cube hops.",
  difficulty: 2,
  palette: PALETTE_CYAN,
  attribution: "\"Sky High\" by Elektronomia [NCS Release] - https://ncs.io/SkyHigh",
  mapper: "Facundo Yoel",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
    hard: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
    extreme: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
  },
});
